import React, { useState, useEffect } from 'react';
import { Home, Bed, UtensilsCrossed, Bath, Trees, Waves, Maximize2, X, Loader2 } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Fallback photos - these are the reliable Airbnb CDN images that always work in production
// Local uploads (/api/uploads/) don't persist in Kubernetes containers
const fallbackPhotos = {
  outdoor: [
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/ee0846e1-39f7-4bb5-b1ef-4b33462b7fd1.jpeg?im_w=1200', alt: 'Oceanfront view with lighthouse' },
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/db26ca03-ba17-4a05-9acd-65d135bf525c.jpeg?im_w=1200', alt: 'Hot tub and Adirondack chairs with ocean view' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/091b1be2-689f-45ae-82ba-4ee19f225be1.jpeg?im_w=1200', alt: 'Fire pit area' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/0fb75c69-4a3d-4dd8-b1f0-59f11c6ade6e.jpeg?im_w=1200', alt: 'Outdoor dining area' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/1c41f40e-778e-4439-a3cd-aba04b12e739.jpeg?im_w=1200', alt: 'Deck with swings' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/218f99a4-6934-4aec-a5a1-bbfac082e425.jpeg?im_w=1200', alt: 'Waterfront view' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/21a800f2-7121-4a67-95be-6e6331088eda.jpeg?im_w=1200', alt: 'Patio furniture' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/2315ce59-48a6-43fe-a272-cbce1dd082ae.jpeg?im_w=1200', alt: 'Outdoor lounge area' }
  ],
  bedrooms: [
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/15f9fb0d-d272-4212-bd87-dbe42705c9aa.jpeg?im_w=1200', alt: 'Bedroom 1 - King bed with ocean views' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/5a7fde05-6d44-422a-84ae-3c8b907be5a8.jpeg?im_w=1200', alt: 'Bedroom 2 - King bed' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6MTQxMTA3MTYyODY4OTMxNDgxNA==/original/8867ac2e-100c-4610-86b5-f2cc0b0b3100.jpeg?im_w=1200', alt: 'Bedroom 3 - King bed with nautical decor' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/de9715d7-5713-409e-87d6-2929fc5abd25.jpeg?im_w=1200', alt: 'Bedroom 4 - Queen bed with single' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/d6dd0824-ae05-48f3-a429-e89d6149ce86.jpeg?im_w=1200', alt: 'Bedroom 5 - Queen bed with single' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/11f586cb-b74f-4eb7-9463-4c0d727aea06.jpeg?im_w=1200', alt: 'Bedroom with ocean view' }
  ],
  living: [
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/e0d95acf-ce42-433e-aec1-0243fb05bebf.jpeg?im_w=1200', alt: 'Living room with ocean views' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/0f4571a1-f75a-4e5e-b2f6-c223fd281573.jpeg?im_w=1200', alt: 'Spacious living area' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/11280a74-d730-456a-832f-1299b43f0441.jpeg?im_w=1200', alt: 'Living room seating' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/2bb65eef-fcbd-4cde-9505-73f5d31dc85d.jpeg?im_w=1200', alt: 'Family room' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/68312449-ffe0-419f-8669-1c4e24f5379c.jpeg?im_w=1200', alt: 'Cozy living space' }
  ],
  kitchen: [
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/260921f9-6c55-4b23-96ad-35bc6c4d2903.jpeg?im_w=1200', alt: 'Modern kitchen and dining' },
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/04a35278-8ba2-42ca-9ccc-cd726f5bf521.jpeg?im_w=1200', alt: 'Full kitchen with appliances' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/21a8c96e-9d66-48ea-9005-fde4321f8358.jpeg?im_w=1200', alt: 'Dining area' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/2cfe2f29-b7ef-4d63-b07f-3045a831d9c6.jpeg?im_w=1200', alt: 'Kitchen island' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/a2f63334-8fdd-4553-ad9d-dba9a2cc28bf.jpeg?im_w=1200', alt: 'Dining table with ocean view' }
  ],
  bathrooms: [
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6MTQxMTA3MTYyODY4OTMxNDgxNA==/original/0e214fc1-33b0-40b1-88fa-c3eac72a32ff.jpeg?im_w=1200', alt: 'Modern bathroom' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/5b40bbf2-6050-48e0-9825-552e9fd48ab1.jpeg?im_w=1200', alt: 'Master bathroom' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/5e9bc980-df48-4c7b-b43a-6ac7cec9fddd.jpeg?im_w=1200', alt: 'Guest bathroom' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/a8119047-45b6-48da-ad41-346571fe33e4.jpeg?im_w=1200', alt: 'Bathroom with shower' }
  ],
  game: [
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/7e3d18ed-bb35-4457-b167-68e40bdfb6ed.jpeg?im_w=1200', alt: 'Game room' },
    { url: 'https://a0.muscache.com/im/pictures/miso/Hosting-1411071628689314814/original/8f5b8f11-928c-4e1c-84e7-cf3adc22891d.jpeg?im_w=1200', alt: 'Entertainment space' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/6ab6fabc-377a-483c-b8b3-94086a1da960.jpeg?im_w=1200', alt: 'Recreation area' },
    { url: 'https://a0.muscache.com/im/pictures/hosting/Hosting-1411071628689314814/original/72a293ae-9491-4651-933e-148397712855.jpeg?im_w=1200', alt: 'Activity room' }
  ]
};

const categoryList = [
  { id: 'outdoor', name: 'Outdoor Amenities', icon: Trees },
  { id: 'bedrooms', name: 'Bedrooms', icon: Bed },
  { id: 'living', name: 'Living Spaces', icon: Home },
  { id: 'kitchen', name: 'Kitchen & Dining', icon: UtensilsCrossed },
  { id: 'bathrooms', name: 'Bathrooms', icon: Bath },
  { id: 'game', name: 'Game Room', icon: Waves }
];

const OrganizedGallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('outdoor');
  const [lightboxImage, setLightboxImage] = useState(null);
  const [photos, setPhotos] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPhotos();
  }, []);

  const fetchPhotos = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/admin/public/images`);
      const allImages = response.data;
      
      // Group images by category — database is the single source of truth
      const grouped = {};
      categoryList.forEach(cat => {
        const dbPhotos = allImages
          .filter(img => img.category === cat.id)
          .map(img => ({
            id: img.id,
            url: img.url.startsWith('http') ? img.url : `${BACKEND_URL}${img.url}`,
            alt: img.alt_text || 'Property image',
          }));
        // Use DB photos if available, otherwise fall back to hardcoded defaults
        grouped[cat.id] = dbPhotos.length > 0 ? dbPhotos : (fallbackPhotos[cat.id] || []);
      });
      
      setPhotos(grouped);
    } catch (error) {
      console.error('Error fetching photos:', error);
      // Use fallback photos only if API is completely unreachable
      setPhotos(fallbackPhotos);
    } finally {
      setLoading(false);
    }
  };

  const getCategoryCount = (categoryId) => {
    return photos[categoryId]?.length || fallbackPhotos[categoryId]?.length || 0;
  };

  const currentPhotos = photos[selectedCategory] || fallbackPhotos[selectedCategory] || [];

  if (loading) {
    return (
      <section id="organized-gallery" className="section-spacing">
        <div className="container-coastal">
          <div className="text-center mb-xl">
            <h2 className="section-title">Explore Our Property</h2>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '4rem' }}>
              <Loader2 size={48} className="animate-spin" style={{ color: 'var(--color-ocean-deep)' }} />
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="organized-gallery" className="section-spacing" data-testid="organized-gallery">
      <div className="container-coastal">
        <div className="text-center mb-xl">
          <h2 className="section-title">Explore Our Property</h2>
          <p className="section-subtitle" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Browse through our stunning oceanfront retreat - from cozy bedrooms to outdoor paradise
          </p>
        </div>

        {/* Category Tabs */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 'var(--spacing-md)',
          marginBottom: 'var(--spacing-2xl)'
        }}>
          {categoryList.map((category) => {
            const IconComponent = category.icon;
            const isActive = selectedCategory === category.id;
            
            return (
              <button
                key={category.id}
                data-testid={`gallery-tab-${category.id}`}
                onClick={() => setSelectedCategory(category.id)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  padding: '0.875rem 1.5rem',
                  background: isActive ? 'var(--color-ocean-deep)' : 'white',
                  color: isActive ? 'white' : 'var(--color-granite-gray)',
                  border: `2px solid ${isActive ? 'var(--color-ocean-deep)' : 'var(--color-coastal-fog)'}`,
                  borderRadius: 'var(--border-radius-lg)',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: isActive ? '0 4px 15px rgba(10, 61, 98, 0.3)' : 'none'
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = 'var(--color-coastal-fog)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = 'white';
                  }
                }}
              >
                <IconComponent size={20} />
                <span>{category.name}</span>
                <span style={{
                  padding: '0.125rem 0.5rem',
                  background: isActive ? 'rgba(255,255,255,0.2)' : 'var(--color-coastal-fog)',
                  borderRadius: 'var(--border-radius)',
                  fontSize: '0.875rem'
                }}>
                  {getCategoryCount(category.id)}
                </span>
              </button>
            );
          })}
        </div>

        {/* Photo Grid */}
        <div className="grid-3" data-testid="photo-grid">
          {currentPhotos.map((photo, index) => (
            <div
              key={photo.id || index}
              className="image-overlay-container"
              data-testid={`gallery-image-${index}`}
              style={{
                height: '280px',
                cursor: 'pointer',
                position: 'relative'
              }}
              onClick={() => setLightboxImage(photo)}
            >
              <img
                src={photo.url}
                alt={photo.alt}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <div className="image-overlay" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Maximize2 size={32} color="white" />
              </div>
            </div>
          ))}
        </div>

        {currentPhotos.length === 0 && (
          <div style={{
            textAlign: 'center',
            padding: 'var(--spacing-2xl)',
            background: 'white',
            borderRadius: 'var(--border-radius-lg)'
          }}>
            <p style={{ color: 'var(--color-granite-gray)', fontSize: '1.125rem' }}>
              No photos available in this category yet.
            </p>
          </div>
        )}

        {/* Lightbox */}
        {lightboxImage && (
          <div
            data-testid="lightbox-modal"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.95)',
              zIndex: 1000,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 'var(--spacing-lg)'
            }}
            onClick={() => setLightboxImage(null)}
          >
            <button
              data-testid="lightbox-close-btn"
              onClick={() => setLightboxImage(null)}
              style={{
                position: 'absolute',
                top: '2rem',
                right: '2rem',
                background: 'rgba(255,255,255,0.1)',
                border: '2px solid white',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'background 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
            >
              <X size={24} color="white" />
            </button>
            <img
              src={lightboxImage.url}
              alt={lightboxImage.alt}
              style={{
                maxWidth: '90%',
                maxHeight: '90%',
                objectFit: 'contain',
                borderRadius: 'var(--border-radius-lg)'
              }}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default OrganizedGallery;
